import { jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import { debounce } from '../../../utils/debounce.es.js';

const tableWrapper = "_table-wrapper_1wcw1_1";
const table = "_table_1wcw1_1";
const styles = {
	tableWrapper: tableWrapper,
	table: table
};

const Table = ({ scrollable, children, collapse = false, kind = "standard" }) => {
  const [isScrolledHorz, setIsScrolledHorz] = useState(false);
  const [isScrolledVert, setIsScrolledVert] = useState(false);
  const setScroll = debounce((target) => {
    const { scrollLeft, scrollTop } = target;
    setIsScrolledHorz(scrollLeft > 0);
    setIsScrolledVert(scrollTop > 0);
  }, 20);
  const onScroll = (e) => {
    setScroll(e.target);
  };
  return jsx("div", { className: styles.tableWrapper, "data-scrollable": scrollable ? true : void 0, "data-scrolled-horz": isScrolledHorz ? true : void 0, "data-scrolled-vert": isScrolledVert ? true : void 0, "data-zds": true, onScroll, children: jsx("table", { className: styles.table, "data-collapse": collapse ? true : void 0, "data-kind": kind, "data-zds": true, role: "table", children }) });
};

export { Table };
//# sourceMappingURL=Table.es.js.map
